var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1h20v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-4.97 0-9 4.054-9 9.055C1 14.574 4.291 18.32 8.594 19v-6.328H6.308v-2.617h2.286V8.06c0-2.27 1.343-3.522 3.4-3.522.984 0 2.014.176 2.014.176v2.228h-1.134c-1.119 0-1.467.698-1.467 1.414v1.699h2.495l-.398 2.617h-2.097V19C15.709 18.32 19 14.573 19 10.055 19 5.054 14.97 1 10 1z",
    stroke: "#1877F3"
  }))));
}
export default SvgFacebook;